/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

import { useCallback, useMemo } from 'react';

import { TNotificationsFooterProps } from '@nexign/scc-ui-kit/lib/components/Notifications/NotificationsFooter';
import isFunction from 'lodash/isFunction';
import { useSelector } from 'react-redux';

import { icons } from '@/main/assets';
import { ImgStyled } from '@/main/components/common/Block/Img';
import { appHistoryPush } from '@/main/modules/app/appHistory';
import { makeSelectUserNotificationsTranslation } from '@/main/modules/internationalization/intSelectors';
import { RoutePath } from '@/main/routes/constants/routesConstants';

import { StyledNotificationsButtonLink } from '../styled/UserNotificationsStyled';

export const useFooterParams = (handleNotificationsClose?: () => void): TNotificationsFooterProps => {
    const notificationTranslation = useSelector(makeSelectUserNotificationsTranslation());

    const { footer: tFooter } = notificationTranslation;

    const handleNewsButtonClick = useCallback(() => {
        appHistoryPush(RoutePath.news);
        if (isFunction(handleNotificationsClose)) {
            handleNotificationsClose();
        }
    }, [handleNotificationsClose]);

    return useMemo(
        () => ({
            footerComponents: [
                <StyledNotificationsButtonLink
                    color="black"
                    size="small"
                    startIcon={<ImgStyled className="small" src={icons.archiveIcon} />}
                    typographyProps={{ variant: 'h5' }}
                    variant="text"
                    onClick={handleNewsButtonClick}
                >
                    {tFooter.newsLink}
                </StyledNotificationsButtonLink>,
            ],
        }),
        [handleNewsButtonClick, tFooter.newsLink],
    );
};
